import { render } from "./galley-page.vue?vue&type=template&id=0824e7ae&scoped=true"
import script from "./galley-page.vue?vue&type=script&lang=js"
export * from "./galley-page.vue?vue&type=script&lang=js"

import "./galley-page.vue?vue&type=style&index=0&id=0824e7ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0824e7ae"]])

export default __exports__